import React, { ReactNode, useContext, useMemo } from 'react';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import MemberRoleInstantChange from 'router/subrouters/DataRoom/components/DataRoomMembersTable/MemberRoleInstantChange';
import { DataRoomMember } from 'router/subrouters/DataRoom/models/DataRoomMember';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';

export type TeamMembersTable = Pick<DataRoomMember, 'fullName' | 'qaRole'>;

export const TABLE_COLUMNS: Array<keyof TeamMembersTable> = [
  'fullName',
  'qaRole',
];

export const HEADING_TRANSLATIONS: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  fullName: 'teamMember',
  qaRole: 'qaRole',
};

export const SIZE_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  fullName: 250,
  qaRole: 50,
};

type CellProps = {
  member: DataRoomMember;
  onChange: (memberId: string, updated: Partial<DataRoomMember>) => void;
};

const FullNameCell: React.FC<CellProps> = ({ member }) => {
  const { fullName, email } = member;

  return <p>{fullName || email || ''}</p>;
};

const QaRoleCell: React.FC<CellProps> = ({ member, onChange }) => {
  const { _id, qaRole, userId } = member;

  const { currentUser } = useContext(CurrentUserContext);
  const { doesntHaveAccess } = useContext(DataRoomContext);

  const canEditQaRole = useMemo(() => {
    const isCurrentUser = userId === currentUser._id;

    if (doesntHaveAccess || isCurrentUser) return false;

    return true;
  }, [currentUser._id, doesntHaveAccess, userId]);

  return (
    <MemberRoleInstantChange
      isBuySide
      memberId={_id}
      qaRole={qaRole}
      {...(canEditQaRole && { onChange: onChange })}
    />
  );
};

export const BODY_CONTENT_GENERATE: Record<
  keyof TeamMembersTable,
  (cellProps: CellProps) => ReactNode
> = {
  fullName: (cellProps: CellProps) => <FullNameCell {...cellProps} />,
  qaRole: (cellProps: CellProps) => <QaRoleCell {...cellProps} />,
};
